import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DsHintModule, DsIconModule, DsLinkModule, DsRowData, DsTableConfig, DsTableModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-translations',
  imports: [DsIconModule, DsTableModule, DsLinkModule, DsHintModule],
  template: `<h2 id="translations-header" class="mb-2x">{{ i18n('adminMode.translationFilesHeading') }}</h2>

    <ds-hint tone="info">{{ i18n('adminMode.translationFilesTemplateHint') }}</ds-hint>

    <table ds-table [(config)]="config" id="translation-files" class="mt-2x">
      @for (row of rowData(); track row.language) {
        <tr ds-table-row>
          <td>
            <ds-link
              id="{{ row['language'] }}.xlsx"
              [href]="'/translations/' + row['language'] + '.xlsx'"
              [label]="row['language'] + '.xlsx'"
            />
          </td>
          <td>
            <ds-link
              id="{{ row['language'] }}.csv"
              [href]="'/translations/' + row['language'] + '.csv'"
              [label]="row['language'] + '.csv'"
            />
          </td>
        </tr>
      }
    </table> `,
  styleUrl: './translations.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslationsComponent {
  readonly languages = input<string[]>([]);

  protected readonly i18n = useI18n();

  protected readonly rowData = computed<DsRowData[]>(() => {
    return this.languages()
      .sort((a, b) => a.localeCompare(b))
      .map((language) => ({
        language: language,
      }));
  });

  protected config: Partial<DsTableConfig> = {
    hasHeader: false,
  };
}
